<template lang="pug">
  .fpui-input-select(v-fp-click-outside='close', :class="className")
    .row
      .fpui-input-label-container.vcenter(@click='toggle', :class='sizeLabel', v-if='label')
        span {{ label | translate }}
        .required-container(v-if='required')
          i.fpui.fpui-required
        fpui-helper(v-if='helper', :text="helper | translate")
      .fpui-input-select-container.vcenter(:class='selectClass')
        .content(@click="toggle",v-show="!showInput")
          .content-html.activeLabel(v-show="showActiveLabel")
            span.basic-label(v-if='!multiple', v-html='activeLabel')
            .multiple-labels(v-else)
              .multiple-label(v-for='label in activeLabel')
                .multiple-label-content
                  span(v-html='label')
                  i.fp.fp-remove(@click="remove(label, $event)")
          .placeholder
            span.content-html(v-if="showPlaceholder", v-html="placeholder")
          i.clear-select.fp.fp-remove(v-if="clearable && value && value.length > 0 && !show", @click="clear")
          i.select-icon.fa.fa-angle-down(v-else-if="!show", aria-hidden="true")
          i.select-icon.fa.fa-angle-up(v-else, aria-hidden="true")


        div.search(v-show="showInput", @click="($event) => $event.stopPropagation()")
          fpui-input-text(
            ref="search",
            :value='search'
            @input='onChangeSearch'
            type="text",
            :placeholder="searchPlaceholder",
            :color='color',
            :disabled='disabled',
            :error='error'
          )
        .fp-scroll(:class='{ openUp }', v-if="show", :style="{ maxHeight: maxHeight + 'px' }")
          ul.dropdown.down(ref='dropdown', v-if='!openUp')
            li(
              v-if="optionsLength > 0"
              @click.stop="selectOption(option, $event)",
              :key="index",
              :class='{ active: isActive(option, index) }'
              v-for="(option, index) in filteredOptions",
              v-html="option.label"
            )
            li(v-if="optionsLength === 0") {{ emptyPlaceholder }}
          ul.dropdown.up(ref='dropdown', v-if="openUp")
            li(v-if="optionsLength === 0") {{ emptyPlaceholder }}
            li(
              v-if="optionsLength > 0"
              @click.stop="selectOption(option, $event)",
              :class='{ active: isActive(option, index) }'
              :key="index",
              v-for="(option, index) in filteredOptions.slice().reverse()",
              v-html="option.label"
            )
    .clearfix
</template>

<script>
  import isEqual from 'lodash/isEqual'

  export default {
    props: {
      options: {
        type: Array,
        default () {
          return []
        }
      },
      value: {
        type: [Array, String],
        default () {
          if (this.multiple) return []
          return ''
        }
      },
      color: { type: String, default: 'grey' },
      placeholder: { type: String, default: '' },
      multiple: { type: Boolean, default: false },
      error: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      clearable: { type: Boolean, default: true },
      emptyPlaceholder: { type: String, default: 'Search result empty' },
      searchPlaceholder: { type: String, default: 'Search' },
      searchable: { type: Boolean, default: false },
      showSelected: { type: Boolean, default: false },
      disableEmptyMessage: { type: Boolean, default: false },
      maxHeight: { type: Number, default: 200 },
      label: { type: String },
      labelSize: { type: Number, default: 3 },
      required: { type: Boolean, default: false },
      withPadding: { type: Boolean, default: false },
      helper: { type: String },
      direction: { type: String }
    },
    data () {
      return {
        show: false,
        search: '',
        openUp: false,
        activeDropdown: 0
      }
    },
    mounted () {
      if (this.options && this.options.length) {
        if (this.multiple && this.value.length > 0) {
          let value = this.value.filter(val => {
            return this.options.some(opt => isEqual(val, opt.value))
          })
          if (value.length !== this.value.length) this.$emit('input', value)
        }
        if (!this.multiple && this.value) {
          let check = this.options.some(opt => isEqual(this.value, opt.value))
          if (!check) this.$emit('input', '')
        }
      }
    },
    methods: {
      selectOption (option) {
        if (option && option.click) return option.click()
        let value = option.value
        if (this.multiple) {
          if (this.value) {
            let check = this.value.find((val) => val === option.value)
            if (check) return
            this.$emit('input', this.value.concat([option.value]))
            if (this.value.length === this.options.length - 1) {
              this.toggle()
            }
          } else {
            this.$emit('input', [option.value])
          }
        } else {
          this.$emit('input', value)
        }
        if (!this.multiple) this.show = false
        if (this.searchable) this.search = ''
        if (this.searchable && this.multiple && this.show) {
          this.$refs['search'].focus()
        }
      },
      onChangeSearch (value) {
        this.search = value
        this.activeDropdown = this.openUp ? this.filteredOptions.length - 1 : 0
      },
      toggle () {
        if (this.disabled) return
        if (this.optionsLength === 0 && this.disableEmptyMessage) {
          return
        }
        this.refreshOpenUp()
        this.show = !this.show
        if (this.show) {
          this.$el.addEventListener('keydown', this.onKeydown)
          process.nextTick(() => this.$refs.search && this.$refs.search.focus())
        } else {
          this.$el.removeEventListener('keydown', this.onKeydown)
        }
      },
      clear (event) {
        event.stopPropagation()
        if (this.multiple) return this.$emit('input', [])
        this.$emit('input', '')
      },
      close () {
        this.show = false
        this.$el.removeEventListener('keydown', this.onKeydown)
      },
      showOption (option) {
        if (this.multiple && this.value) {
          return !this.value.some((value) => {
            let check = isEqual(option.value, value)
            return check
          })
        }
        if (this.value && !this.showSelected) {
          if (isEqual(option.value, this.value)) return false
        }
        return true
      },
      isActive (option, idx) {
        if (this.showSelected) return this.value === option.value
        return idx === this.activeDropdown
      },
      remove (label, event) {
        if (event) {
          event.stopPropagation()
        }
        if (!this.multiple) return
        let option = this.options.find(opt => opt.label === label || opt.labelValue === label)
        if (option) {
          this.$emit('input', this.value.filter(val => !isEqual(val, option.value)))
        }
      },
      getParentWithOverflow (el) {
        if (!el) return null
        let style = window.getComputedStyle(el)
        if (style.overflow === 'auto') {
          return el
        }
        return this.getParentWithOverflow(el.parentNode)
      },
      refreshOpenUp () {
        if (this.direction && this.direction == 'bottom') {
          this.openUp = false
          return
        }
        if (this.direction && this.direction == 'top') {
          this.openUp = true
          return
        }
        let parentOverflow = this.getParentWithOverflow(this.$el.parentNode)
        if (!parentOverflow) {
          this.openUp = false
          return
        }
        let parentBottom = parentOverflow.getBoundingClientRect().bottom
        let bottom = this.$el.getBoundingClientRect().bottom
        let heightDropdown = this.options.length === 0 ? 39 : this.optionsLength * 36
        if (heightDropdown > this.maxHeight) heightDropdown = this.maxHeight
        if (this.searchable) heightDropdown += 39
        this.openUp = parentBottom - bottom < heightDropdown
        if (this.openUp) this.activeDropdown = this.options.length - 1
        else this.activeDropdown = 0
      },
      onKeydown (e) {
        let position = this.$refs.dropdown.parentNode.scrollTop
        // Key escape
        if (e.keyCode === 27) return this.close()
        // Key up
        if (e.keyCode === 38) {
          this.$refs.dropdown.parentNode.scrollTo(0, position - 36)
          if (this.openUp && this.activeDropdown <= this.options.length - 2) this.activeDropdown += 1
          if (!this.openUp && this.activeDropdown > 0) this.activeDropdown -= 1
        }
        // Key down
        if (e.keyCode === 40) {
          this.$refs.dropdown.parentNode.scrollTo(0, position + 36)
          if (!this.openUp && this.activeDropdown <= this.options.length - 2) this.activeDropdown += 1
          if (this.openUp && this.activeDropdown > 0) this.activeDropdown -= 1
        }
        // Key enter
        if (e.keyCode === 13) {
          this.selectOption(this.filteredOptions[this.activeDropdown])
        }
      }
    },
    computed: {
      className () {
        let className = [`fpui-input-color-${this.color}`]
        if (this.disabled) className.push('disabled')
        if (this.error) className.push('error')
        if (this.show) className.push('is-open')
        return className.join(' ')
      },
      selectClass () {
        let className = []
        let size = 12
        if (this.label) size -= this.labelSize
        className.push(`col-xs-${size}`)
        if (this.withPadding) className.push('with-padding')
        return className.join(' ')
      },
      sizeLabel () { return `col-xs-${this.labelSize}` },
      activeLabel () {
        if (this.multiple && this.value) {
          let ret = this.value.map((value) => {
            let option = this.options.find((option) => isEqual(option.value, value))
            if (!option) return value
            return option.labelValue || option.label
          })
          return ret
        }
        let active = this.options.find((option) => isEqual(option.value, this.value))
        if (active) return active.label
        return ''
      },
      filteredOptions () {
        return this.options.filter((option) => {
          let inSearch = true
          if (this.search) {
            let num = option.label.toLowerCase().trim().indexOf(this.search.toLowerCase().trim())
            inSearch = num !== -1
          }
          return this.showOption(option) && inSearch
        })
      },
      optionsLength () { return this.filteredOptions.length },
      showActiveLabel () { return this.value && this.value.length > 0 },
      showPlaceholder () { return !this.showActiveLabel },
      showInput () {
        return this.show && this.searchable
      }
    }
  }
</script>

<style lang="less">
@import "~@/shared/styles/_variables.less";

@selectHeight: 35px;

.fpui-input-select {
  position:relative;
  z-index: 10;
  .fpui-input-label-container {
    padding-left: 0;
    cursor: pointer;
    .required-container {
      display: inline-block;
      margin-right: 7px;
      margin-top: -10px;
      width: 15px;
      vertical-align: middle;
      font-size: 22px;
      text-align: center;
      color: @blue;
      border-radius: 50%;
    }
  }
  .fpui-input-select-container {
    cursor: pointer;
    &:not(.with-padding) {
      padding: 0;
    }
  }
  .fp-scroll {
    width: 100%;
    overflow: auto;
    min-height: 100%;
    position:absolute;
    background-color: #fff;
    border: 1px solid #ccc;
    border-top-color: #e6e6e6;
    box-shadow: 0 1px 0 rgba(0,0,0,.06);
    &.openUp {
      bottom: @selectHeight;
    }
  }


  div.search {
    position: sticky;
    padding: 0px;
    input {
      padding: 7px;
      height: @selectHeight;
    }
    &:hover {
      background-color: transparent;
    }
  }

  .dropdown {
    padding: 0;
    margin: 0;
    width: 100%;
    list-style: none;
    z-index: 1000;
    li {
      line-height: 14px;
      padding: 8px 10px;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor:pointer;
      &:hover {
        background-color: #f5f5f5;
      }
      &.active {
        background-color: #f5f5f5;
      }
    }
  }
  .content {
    overflow: hidden;
    position:relative;
    padding:0!important;
    background: transparent!important;
    border: none;
    background:linear-gradient(180deg, #ffffff 0%, #fefefe 1%, #f8f8f8 100%) !important;
    border: 1px solid @grey;
    font-size: 1em;
    font-weight: 300;
    letter-spacing: 1px;
    outline: none;
    border-radius: 2px;
    height: @selectHeight;
    .content-html {
      width: 85%;
      font-size:12px;
      white-space: nowrap;
      overflow-y: hidden;
      overflow-x: auto;
      text-overflow: ellipsis;
    }
    .placeholder {
      color: grey;
      padding-left: 10px;
      line-height: @selectHeight;
      overflow-y: hidden;
      overflow-x: auto;
      text-overflow: ellipsis;
      width: 90%;
      margin-top: 0;
    }
    .clear-select {
      position:absolute;
      right: 5px;
      top: 0;
      font-size: 20px;
    }
    .select-icon {
      font-size:20px;
      position:absolute;
      right: 5px;
      top: 47%;
      transform:translateY(-50%);
    }
  }
  &.is-open {
    z-index: 11;
    &.fpui-input-color-blue:not(.error) .content {
      border-color: @blue;
    }
    &.fpui-input-color-green:not(.error) .content {
      border-color: @green;
    }
    &.fpui-input-color-red, &.error {
      border-color: @red;
    }
    &.fpui-input-color-yellow:not(.error) .content {
      border-color: @yellow;
    }
    &.fpui-input-color-grey:not(.error) .content {
      border-color: #8c8c8c;
    }
  }
  .activeLabel {
    position: absolute;
    left: 10px;
    top: 0;
    height: @selectHeight;
    .basic-label {
      line-height: @selectHeight;
    }
    .multiple-labels {
      height: 100%;
      .multiple-label {
        font-size: 12px;
        height: 30px;
        border-radius: 2px;
        display: inline-block;
        margin-left: 3px;
        margin-top: 5px;
        padding: 6px 15px;
        position: relative;
        background-color: @blue;
        color: @white;
        .multiple-label-content {
          height: 100%;
        }
        i.fp {
          font-size: 13px;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
    }
  }
  &.error {
    .content {
      border: 1px solid @red;
    }
  }
  &.disabled {
    .fpui-input-select-container {
      cursor: not-allowed;
      .select-icon {
        color: @grey;
      }
    }
    .content {
      background-color: @grey !important;
    }
  }
  .fpui-input-select-container.with-padding {
    .fp-scroll {
      width: calc(~"100% - 30px");
    }
  }
}
</style>
